import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, tap } from 'rxjs/operators';
import { ApiResponse } from '../models/response.model';
import { ActiveToast, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class MediaService {

  activeToaster?: ActiveToast<any>;
  _mediaEndpoint = `${environment.apiBaseUrl}/media/v1/medias`;

  constructor(
    private _toastr: ToastrService,
    private _http: HttpClient) { }

  private showUploading(isUploading: boolean) {
    if (isUploading) {
      this.activeToaster = this._toastr.success('Uploading...', '', {
        progressBar: true,
        progressAnimation: 'increasing',
        timeOut: 10000,
      });
    } else {
      this._toastr.clear(this.activeToaster?.toastId);
    }
  }
  upload(fileToUpload: File): Observable<any> {
    this.showUploading(true);
    const formData: FormData = new FormData();
    formData.append('mediaType', 'image');
    formData.append('media', fileToUpload, fileToUpload.name);
    return this._http.post<ApiResponse<any>>(this._mediaEndpoint, formData)
      .pipe(
        map((res) => res.data),
        tap({ complete: () => this.showUploading(false), })
      );
  }

  uploadDocument(fileToUpload: File): Observable<any> {
    this.showUploading(true);
    const formData: FormData = new FormData();
    formData.append('mediaType', 'document');
    formData.append('media', fileToUpload, fileToUpload.name);
    return this._http.post<ApiResponse<any>>(this._mediaEndpoint, formData)
      .pipe(
        map((res) => res.data),
        tap({ complete: () => this.showUploading(false), })
      );
  }

  uploadMediaV2({ file, entity, entityType, order, label, }: { file: any, order?: number, label?: string, entity?: string, entityType?: string }): Observable<any> {
    const fd = new FormData();
    if (entity) fd.append('entity', entity);
    if (entityType) fd.append('entityType', entityType);
    if (label) fd.append('label', label);
    if (order) fd.append('order', `${order}`);
    // Note: keep media at the bottom
    fd.append('media', file, file.name);

    return this._http.post<ApiResponse<any>>(`${this._mediaEndpoint}`, fd)
      .pipe(map((res: any) => res.data), tap({ complete: () => this.showUploading(false), }));
  }

}